import { Button, Card } from '@repo/shadcn';

import { SectionContainer } from '@components/shared';
import {
    HeaderBreadcrumb,
    SectionDataTable,
    SectionTitle,
} from '@components/ui';

import { Route } from '../../../../constants';
import { ProductSectionFilters } from '../../product-section-filters.component';
import { unitListColumns } from './unit-list.column';
import { useUnitList } from './unit-list.hook';

export const UnitList = () => {
    const { data, isLoading, isError, error, isFetching, handleCreateUnit } =
        useUnitList();

    return (
        <SectionContainer isError={isError} isLoading={isLoading} error={error}>
            <Card className={'space-y-4 p-4'}>
                <div className={'flex items-start justify-between'}>
                    <div className={'space-y-2'}>
                        <HeaderBreadcrumb
                            items={[
                                { label: 'Products', href: Route.PRODUCTS },
                                { label: 'Units' },
                            ]}
                        />
                        <SectionTitle>Unit List (Pack Size)</SectionTitle>
                    </div>
                    <Button onClick={handleCreateUnit} type={'button'}>
                        Create New Unit
                    </Button>
                </div>
                <ProductSectionFilters />
                <SectionDataTable
                    columns={unitListColumns}
                    data={data}
                    isLoading={isLoading || isFetching}
                />
            </Card>
        </SectionContainer>
    );
};

UnitList.displayName = 'UnitList';
